<router-outlet data-automation-id="sustainability shell"></router-outlet>
